import React, { useState } from "react";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Container, Row, Col, } from "react-bootstrap";

import Sidebar from "../../comman_page/Sidebar";
import { Footer } from "../../../../../public/containers/footer/Footer";
import Tooltips from "../../../../../client-staff/Components/CommanPages/Tooltips";
import Swal from "sweetalert2";
import logo from "../../../../../Images/logo_white_web.png"
import { useNavigate } from "react-router-dom";


export const DiscountCodeRequested = () => {
    const [amountType, setAmountType] = useState('dollar');
    const navigate = useNavigate();

    const subscribeHandler = () => {
        Swal.fire({
            html: `
                <img src="${logo}" class="img-fluid d-block mx-auto mt-4" alt="logo" />
                <h4 class="title text-capitalize text-center mt-4 textWhite">
                    Request Already Submitted
                </h4>
                <div class="text-center my-3">
                    <p class="textWhite">
                        Your subscription request for <strong>Marketing & Discount Codes</strong> 
                        has already been sent to the admin for approval.
                    </p>
                    <p class="textWhite mt-2">
                        <strong>Status:</strong> <span style="color: #f0ad4e;">Pending Approval</span>
                    </p>
                    <p class="textWhite">
                        <strong>Feature:</strong> Marketing & Discount Codes
                    </p>
                    <p class="textWhite">
                        <strong>Price:</strong> $25/month
                    </p>
                    <p class="textWhite mt-3">
                        You will be notified once your request has been reviewed and approved by the admin team.
                    </p>
                </div>
            `,
            showCancelButton: false,
            confirmButtonText: "OK",
            confirmButtonColor: "#3085d6",
            showClass: {
                popup: "custom-dialog-container custom-swal-popup",
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                navigate('/Home');
            }
        });
    };


    return (
        <>
            <div className="MainDashboard">
                <div className="MainLayout">
                    <Row>
                        <Sidebar />
                        <Col>
                            <div className="RightSide">
                                <HeaderDashboard />
                                <section className="addClient innerContent">
                                    <div className="AddClientContent">

                                        <Container className="mb-5 pb-4">
                                            <div className="d-flex justify-content-between mb-3">
                                                <h4>Marketing & Discount Codes</h4>
                                                <button
                                                    onClick={subscribeHandler}
                                                    type="button"
                                                    class="btn btn-success px-2 py-1" style={{ fontSize: '1rem' }}>
                                                    Subscribe Approval Requested
                                                    <span className="ml-2">
                                                        <Tooltips
                                                            myPlacement="left"
                                                            info={
                                                                'Marketing & Discount Codes is a premium add-on. Activating this feature costs $25/month. Once subscribed, an approval request will be sent to the admin. After approval, you can create and manage promotion codes for workshops and passes, and allow customers to apply codes at checkout (web, mobile, and admin checkout).'
                                                            }
                                                        />

                                                    </span>
                                                </button>
                                            </div>
                                            <p className="open-sans">
                                                Marketing tools allow you to create and manage promotional discount
                                                codes for passes and workshops. This premium feature lets you offer
                                                special pricing that clients can apply at checkout—online, in the
                                                mobile app, or when processed by an admin. Once activated, you can
                                                create, enable, or disable discount codes, control their usage, and
                                                encourage new purchases through targeted promotions.
                                            </p>


                                            <Row className="mt-5">
                                                <hr />
                                                <Row className='mt-5'>
                                                    <Col className="col-md-6 mb-3">
                                                        <label className="form-label inputLable">Discount code name</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name='d_code'
                                                            id="d_code"
                                                            readOnly
                                                            style={{
                                                                background: '#dadada',
                                                                cursor: 'not-allowed'
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col className="col-md-6 mb-3">
                                                        <div className="form-label inputLable mb-0 d-flex gap-2">
                                                            <div>
                                                                <label class="switch mb-2 discount-switch">
                                                                    <input type="checkbox" id="discountType" onChange={(e) => { e.target.checked ? setAmountType('percent') : setAmountType('dollar') }} />
                                                                    <span class="slider discount-slider round" style={{ backgroundColor: "#02793f" }}>
                                                                        <span class="label-dollar">$</span>
                                                                        <span class="label-percent">%</span>
                                                                    </span>
                                                                </label>

                                                            </div>
                                                            <div>
                                                                {amountType === 'percent' ?
                                                                    <label className="form-label inputLable mb-2">Percent</label>
                                                                    :
                                                                    <label className="form-label inputLable mb-2">Amount</label>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div>
                                                            {amountType === 'percent' ?
                                                                <span className="form-label input-label input-icon">%</span>
                                                                :
                                                                <span className="form-label input-label input-icon">$</span>
                                                            }
                                                            <input
                                                                style={{
                                                                    paddingLeft: '30px',
                                                                    background: '#dadada',
                                                                    cursor: 'not-allowed',
                                                                }}
                                                                type='text'
                                                                name='amount'
                                                                className={"form-control"}
                                                                readOnly={true}
                                                            />
                                                        </div>
                                                    </Col>

                                                    <Col className="col-md-6 mb-3">
                                                        <label className="form-label inputLable">  Promo Start date</label>
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            name='start_date'
                                                            id="start_date"
                                                            readOnly
                                                            style={{
                                                                background: '#dadada',
                                                                cursor: 'not-allowed'
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col className="col-md-6 mb-3">
                                                        <label className="form-label inputLable">  Promo End  Day</label>
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            name='end_date'
                                                            id="end_date"
                                                            readOnly
                                                            style={{
                                                                background: '#dadada',
                                                                cursor: 'not-allowed'
                                                            }}
                                                        />
                                                    </Col>

                                                    <Col className="col-md-6 mb-3">
                                                        <label className="form-label inputLable">Single use per client?</label>
                                                        <div style={{
                                                            background: '#dadada',
                                                            border: '2px solid black',
                                                            borderRadius: '10px',
                                                        }}>
                                                            <select
                                                                className="form-select"
                                                                name=''
                                                                disabled
                                                                aria-label="Default select example"
                                                                style={{
                                                                    opacity: 1,
                                                                    cursor: 'not-allowed',
                                                                    WebkitAppearance: 'none',
                                                                    MozAppearance: 'none',
                                                                    appearance: 'none'
                                                                }}
                                                            >
                                                                <option selected readOnly value="" >select</option>
                                                            </select>
                                                        </div>
                                                    </Col>
                                                    <Col className='col-md-6 mb-3'>
                                                        <label className="form-label inputLable">   Apply to the following items</label>
                                                        <Row className="row mt-2 ml-1">
                                                            <Col className='col-md-4 mb-3'>
                                                                <div className='form-check'>
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        name='passes'
                                                                        id="passes"
                                                                        disabled
                                                                        style={{
                                                                            background: '#dadada',
                                                                            opacity: 1,
                                                                            cursor: 'not-allowed',
                                                                            WebkitAppearance: 'none',
                                                                            MozAppearance: 'none',
                                                                            appearance: 'none'
                                                                        }}
                                                                    />
                                                                    <label className="form-label" htmlFor="passes">
                                                                        <strong style={{ color: 'black' }}> passes </strong>
                                                                    </label>
                                                                </div>
                                                            </Col>

                                                            <Col className='col-md-4 mb-3'>
                                                                <div className='form-check'>
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        name='products'
                                                                        id="products"
                                                                        disabled
                                                                        style={{
                                                                            background: '#dadada',
                                                                            opacity: 1,
                                                                            cursor: 'not-allowed',
                                                                            WebkitAppearance: 'none',
                                                                            MozAppearance: 'none',
                                                                            appearance: 'none'
                                                                        }}
                                                                    />
                                                                    <label className="form-label" htmlFor="products">
                                                                        <strong style={{ color: 'black' }}> products </strong>
                                                                    </label>
                                                                </div>
                                                            </Col>
                                                            <Col className='col-md-4 mb-3'>
                                                                <div className='form-check'>
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        name='workshops'
                                                                        id="workshops"
                                                                        disabled
                                                                        style={{
                                                                            background: '#dadada',
                                                                            opacity: 1,
                                                                            cursor: 'not-allowed',
                                                                            WebkitAppearance: 'none',
                                                                            MozAppearance: 'none',
                                                                            appearance: 'none'
                                                                        }}
                                                                    />
                                                                    <label className="form-label" htmlFor="workshops">
                                                                        <strong style={{ color: 'black' }}> workshops  </strong>
                                                                    </label>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col className="col-md-12 mt-4 d-flex justify-content-end">
                                                        <button className="btnform w-50"
                                                            style={{
                                                                padding: '10px 10px',
                                                                cursor: 'not-allowed',
                                                                border: '2px solid black',
                                                                borderRadius: '10px',
                                                                background: '#dadada',
                                                                color: "#fff",
                                                                fontSize: '20px',
                                                                fontWeight: '700'
                                                            }}
                                                        >
                                                            Save
                                                        </button>

                                                    </Col>
                                                </Row>
                                            </Row>
                                        </Container>
                                    </div>
                                </section>
                                <Footer />
                            </div>
                        </Col>
                    </Row >
                </div >
            </div >
        </>
    );
};
